<template>
  <div>
    <el-header id="header">
      <span class="hideAside" @click="collapse"><i class="fa fa-indent fa-lg"></i></span>
      <ul class="personal">
        <li class="fullScreen" @click="fullScreen">
          <el-tooltip class="item" effect="dark" content="全屏" placement="bottom"><i
            class="fa fa-arrows-alt fa-lg"></i></el-tooltip>
        </li>
        <li v-if="userType === 'tutor'">
          <el-switch v-model="isOnLineStatus" active-color="#13ce66" inactive-color="#ff4949"
                     :active-text="$t('common.OnLine')" :inactive-text="$t('common.OffLine')" @change="changeOnLineStatus">
          </el-switch>
        </li>
        <li>
          <langSelect></langSelect>
        </li>
<!--        <li>{{ $t(`role.${this.$store.getters.info.role}`) }}</li>-->
        <li>
          <el-dropdown @command="handleCommand">
                  <span class="el-dropdown-link">
                    {{userName}}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
            <el-dropdown-menu slot="dropdown">
              <!--<el-dropdown-item command="a">{{ $t('userDropdownMenu.basicInfor') }}</el-dropdown-item>-->
              <el-dropdown-item command="changePassword">{{ $t('userDropdownMenu.changePassword') }}</el-dropdown-item>
              <el-dropdown-item command="logout" divided>{{ $t('userDropdownMenu.logout') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
        <!--<li class="icon"><img :src="avatar"/></li>-->
      </ul>
    </el-header>
    <tabNav></tabNav>

    <el-dialog :title="title" :visible.sync="dialogFormVisible">
      <el-form :model="form" label-width="80px">
        <el-form-item label="原密码 " prop="oldPassword">
          <el-input v-model="form.oldPassword" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="form.newPassword" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码 " prop="reNewPassword">
          <el-input v-model="form.reNewPassword" show-password></el-input>
        </el-form-item>
        <el-button type="primary" @click="updateUser(form)">确 定</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import jq from 'jquery'
import langSelect from '../../../components/lang/langSelect'
import tabNav from './tabNav'

export default {
  name: 'Header',
  components: {tabNav, langSelect},
  data () {
    return {
      isOnLineStatus: false,
      userName: '',
      isfullScreen: true,
      avatar: './static/images/icon.jpg',
      userType: '', // 登录的用户类型
      userInfoId: '', // 登录的用户Id
      form: {
        oldPassword: '',
        newPassword: '',
        reNewPassword: ''
      },
      // 新增or编辑弹框标题(根据点击的新增or编辑按钮显示不同的标题)
      title: '',
      // 新增和编辑弹框标题
      dialogStatus: '',
      // 是否弹出对话框
      dialogFormVisible: false
    }
  },
  methods: {
    changeOnLineStatus () {
      if (this.isOnLineStatus) {
        this.tutorOnLine()
      } else {
        this.tutorOffLine()
      }
    },
    // 导师tutor  的上下线
    tutorOnLine () {
      this.$api.myg.onLine(this.qs.stringify({tutorId: this.userInfoId, tutorName: this.userName})).then(res => {
        if (!res || res.data.code !== '0000' || res.data.status === 'N') {
          this.isOnLineStatus = false
        }
      })
    },
    tutorOffLine () {
      this.$api.myg.offLine(this.qs.stringify({tutorId: this.userInfoId, tutorName: this.userName})).then(res => {
        if (!res || res.data.code !== '0000' || res.data.status === 'N') {
          this.isOnLineStatus = true
        }
      })
    },
    // 导师是否在线
    tutorIsOnline () {
      // 查询导师在线状态，并回写到列表中
      // this.$api.myg.findTutorStatus({data: {tutorIds: [this.userInfoId]}}).then(res => {
      //   let data = res.data.data
      //   if (data[0].status === 40) {
      //     this.isOnLineStatus = false
      //   } else if (data[0].status === 50) {
      //     this.isOnLineStatus = true
      //   }
      // })
    },
    updateUser (form) {
      if (form.newPassword != form.reNewPassword) {
        this.$message({
          showClose: true,
          message: '两次输入密码不一致',
          type: 'error'
        })
        return false
      }
      let userId = JSON.parse(localStorage.getItem('user')).userId
      let userType = JSON.parse(localStorage.getItem('user')).userType
      let param = {
        data: {
          userId: userId,
          type: userType,
          oldPassword: form.oldPassword,
          newPassword: form.newPassword
        }
      }
      this.$axios({
        method: 'post',
        url: this.global.BASE_ACL + '/user/updateUserPasswd',
        data: JSON.stringify(param),
        headers: {
          certificate: Cookies.get(`token_${window.location.port}`),
          'Content-Type': 'application/json'
        }
      }).then((response) => {
        if (response.data.status === 'Y') {
          this.$message({
            showClose: true,
            message: response.data.data,
            type: 'success'
          })
          Cookies.remove('token')
          location.reload()
        } else {
          this.$message({
            showClose: true,
            message: response.data.data,
            type: 'error'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    collapse () {
      this.$store.dispatch('collapse')
    },
    message () {
      const h = this.$createElement
      this.$notify({
        title: '警告',
        message: h('i', {style: 'color: teal'}, ''),
        duration: 6000
      })
    },
    fullScreen () {
      if (this.isfullScreen) {
        var docElm = document.documentElement
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen()
        } else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen()
        } else if (docElm.webkitRequestFullScreen) {
          docElm.webkitRequestFullScreen()
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen()
        }
        this.isfullScreen = false
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
        this.isfullScreen = true
      }
    },
    handleCommand (command) {
      if (command === 'logout') {
        // 退出方法
        new Promise((resolve,reject)=>{
          this.tutorOffLine()
          resolve()
        }).then(() => {
          this.$axios({
            method: 'post',
            url: this.global.BASE_DMZ + '/staff/logout',
            headers: {
              certificate: Cookies.get(`token_${window.location.port}`)
            },
            //   beforeSend: function(request) {
            // 	  debugger
            // 	 request.setRequestHeader("token", Cookies.get(`token_${window.location.port}`));
            // },
            data: this.qs.stringify({
              certificate: Cookies.get(`token_${window.location.port}`)
            })
          }).then((response) => {
            Cookies.remove('token')
            location.reload()
          }).catch((error) => {
            console.log(error) // 请求失败返回的数据
          })
        })
      } else if (command === 'changePassword') {
        this.form.title = '修改密码'
        this.dialogFormVisible = true
      }
    },
    beforeunloadHandler(){
      this._beforeUnload_time=new Date().getTime();
    },
    unloadHandler(e){
      this._gap_time=new Date().getTime()-this._beforeUnload_time;
      let datas = {
        tutorId: this.userInfoId,
        tutorName: this.userName
      }
      //判断是窗口关闭还是刷新
      if(this._gap_time<=5){
        jq.ajax({
          url: this.global.MYG_1V1 + '/tutor/offline',
          type: 'post',
          async: false,
          data: datas,
          headers: {
            certificate: Cookies.get(`token_${window.location.port}`)
          },
          success: function (res) {
            console.log(res)
          }
        })
      }
    }
  },
  created: function () {
    let userName = JSON.parse(localStorage.getItem('user')).userName
    this.userType = JSON.parse(localStorage.getItem('user')).userType
    this.userInfoId = JSON.parse(localStorage.getItem('user')).userInfoId
    this.tutorIsOnline()
    if (userName) {
      this.userName = userName
    }
  },
  mounted () {
    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
    window.addEventListener('unload', e => this.unloadHandler(e))
  }
}
</script>

<style lang="scss">
  $top: top;
  $bottom: bottom;
  $left: left;
  $right: right;
  $leftright: ($left, $right);
  %w100 {
    width: 100%;
  }

  %h100 {
    height: 100%;
  }

  %cursor {
    cursor: pointer;
  }

  html, body, #app, .el-container, #asideNav, ul.el-menu {
    @extend %h100;
  }

  @mixin set-value($side, $value) {
    @each $prop in $leftright {
      #{$side}-#{$prop}: $value;
    }
  }

  #header {
    max-height: 50px;
    line-height: 50px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .05);
    display: flex;
    justify-content: space-between;

    .hideAside {
      @extend %cursor;
    }

    .personal {
      display: flex;
      flex-direction: row;

      li {
        @include set-value(margin, 13px);
        font-size: 12px;
      }

      .fullScreen {
        @extend %cursor;
      }

      .el-dropdown-link {
        @extend %cursor;
      }

      .icon img {
        margin-#{$top}: 7px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        width: 40px;
        height: 40px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/header/header.vue